import { render } from "./index.vue?vue&type=template&id=b0f00f4e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=b0f00f4e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b0f00f4e"

export default script